import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface SiteSettings {
  phone: string;
  email: string;
  address: string;
  instagram_handle: string;
  behold_feed_id: string;
  snapwidget_embed_id: string;
  snapwidget_mobile_width: string;
  snapwidget_mobile_height: string;
  snapwidget_tablet_width: string;
  snapwidget_tablet_height: string;
  snapwidget_desktop_height: string;
  promo_banner_enabled: string;
  promo_banner_title: string;
  promo_banner_subtitle: string;
  promo_banner_detail: string;
  promo_banner_link: string;
  google_review_url: string;
  google_reviews_enabled: string;
  lookbook_show_on_home: string;
}

const defaults: SiteSettings = {
  phone: "(555) 123-4567",
  email: "bookings@inparadisebeauty.com",
  address: "123 Beauty Blvd, Suite 100",
  instagram_handle: "@paridisebeautyinc_",
  behold_feed_id: "",
  snapwidget_embed_id: "1118656",
  snapwidget_mobile_width: "440",
  snapwidget_mobile_height: "560",
  snapwidget_tablet_width: "768",
  snapwidget_tablet_height: "560",
  snapwidget_desktop_height: "600",
  promo_banner_enabled: "true",
  promo_banner_title: "New Suite Special!",
  promo_banner_subtitle: "Any Medium or Long fullset",
  promo_banner_detail: "1 hour 30 minutes @ $75.00",
  promo_banner_link: "/book",
  google_review_url: "",
  google_reviews_enabled: "false",
  lookbook_show_on_home: "false",
};

let cachedSettings: SiteSettings | null = null;
let cacheTimestamp = 0;
const CACHE_TTL = 60_000; // 1 minute

export const invalidateSiteSettingsCache = () => {
  cachedSettings = null;
  cacheTimestamp = 0;
};

export const useSiteSettings = () => {
  const [settings, setSettings] = useState<SiteSettings>(cachedSettings || defaults);
  const [loading, setLoading] = useState(!cachedSettings);

  useEffect(() => {
    // Use cache if fresh
    if (cachedSettings && Date.now() - cacheTimestamp < CACHE_TTL) {
      setSettings(cachedSettings);
      setLoading(false);
      return;
    }

    const fetch = async () => {
      const { data } = await supabase.from("site_settings").select("key, value");
      if (data) {
        const s = { ...defaults };
        data.forEach((row) => {
          if (row.key in s) {
            (s as any)[row.key] = row.value;
          }
        });
        cachedSettings = s;
        cacheTimestamp = Date.now();
        setSettings(s);
      }
      setLoading(false);
    };
    fetch();
  }, []);

  return { settings, loading };
};
